module.exports = __webpack_public_path__ + "static/media/close.886882f9.svg";